"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentSource = void 0;
var SegmentSource;
(function (SegmentSource) {
    SegmentSource["STANDARD"] = "standard";
    SegmentSource["INLINE"] = "inline";
    SegmentSource["ADHOC"] = "adhoc";
})(SegmentSource = exports.SegmentSource || (exports.SegmentSource = {}));
//# sourceMappingURL=segment-source.js.map